import { Component, OnInit } from '@angular/core';
import { CorporateService } from '../corporate-service/corporate-service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';

@Component({
  selector: 'app-configurations-list',
  templateUrl: './configurations-list.component.html',
  styleUrls: ['./configurations-list.component.css']
})
export class ConfigurationsListComponent implements OnInit {
mappers: any = [];
finalMapper = [];
fundingSources :any= [];
fundingSourceName= []
search;
  constructor(private corporateService: CorporateService) { }

  ngOnInit() {
    this.getFundingSource();

  }




  getFundingSource() {
    this.corporateService
      .getCorporateUsers('active')
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.fundingSources = data;
          this.fundingSourceName = data.reduce((obj, item) => (obj[item._id] = item, obj), {})

        }
        this.getConfigurations();

      });

  }

  getConfigurations(){
    this.corporateService
    .getConfigurations()
    .pipe(takeUntil(componentDestroyed(this)))
    .subscribe(data => {
      if (data) {
        this.mappers = data;
      }
    });
  }

  ngOnDestroy(): void {
  }
}
